import { BrandTypographyStyle } from "../../../models/brand.model.ts";
import { httpRequest } from "../../http";

/** The fields a typography style takes; all of them, on create and on update. */
export type BrandTypographyStyleFields = Omit<BrandTypographyStyle, "id">;

export const brandTypographyStylesUrl = (organizationId: string, brandId: string) =>
    `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/organizations/${organizationId}/brands/${brandId}/typography-styles/`;

/** The brand's live typography styles, oldest first. */
export class CommandGetBrandTypographyStyles {
    async run(organizationId: string, brandId: string): Promise<BrandTypographyStyle[]> {
        return await httpRequest<BrandTypographyStyle[]>(brandTypographyStylesUrl(organizationId, brandId), { method: "GET" });
    }
}
